import { useEffect, useRef } from 'react';
import { backButton } from '@telegram-apps/sdk-react';

/**
 * Нативная кнопка «назад» Telegram. Показываем её, только когда назад
 * действительно есть куда — иначе пользователь жмёт кнопку и ничего не
 * происходит.
 */
export function useTelegramBackButton(enabled: boolean, onBack: () => void): void {
  // Вызывающая сторона почти всегда передаёт инлайновую стрелку — её
  // идентичность меняется на каждый рендер. Если бы `onBack` был в
  // зависимостях эффекта ниже, кнопка назад скрывалась и показывалась заново
  // при каждом ре-рендере страницы (например, когда подгрузились данные) —
  // видимый скачок шапки в момент открытия экрана. Реф хранит актуальный
  // колбэк без переподписки.
  const onBackRef = useRef(onBack);
  onBackRef.current = onBack;

  useEffect(() => {
    if (!enabled) return;

    let offClick: VoidFunction | undefined;
    try {
      backButton.show.ifAvailable();
      offClick = backButton.onClick(() => onBackRef.current());
    } catch {
      // Клиент не поддерживает back button — в UI остаётся своя кнопка «Назад».
    }

    return () => {
      offClick?.();
      try {
        backButton.hide.ifAvailable();
      } catch {
        // См. выше.
      }
    };
  }, [enabled]);
}
